module.exports = __webpack_public_path__ + "img/pic02@2x.0564c023.png";